import { APIRoutes } from "@/api";
import { ApiService } from "@/services/api/api-service";
import { userSearchSchema } from "@/services/users/schema";
import {
  QueryFunctionContext,
  useQuery as useQueryTanstack,
} from "@tanstack/react-query";
import { useSession } from "next-auth/react";

async function getUsers({
  queryKey,
  signal,
}: QueryFunctionContext<ReturnType<typeof SearchUsersQuery.keys.userSearch>>) {
  const name = queryKey[3];
  const params = new URLSearchParams({ name });
  const url = `${APIRoutes.USERS_SEARCH}?${params.toString()}`;

  const data = await fetch(url, {
    cache: "no-cache",
    signal,
  }).then((res) => res.json());

  const response = ApiService.parseApiResponse(data, userSearchSchema);

  if (response.status !== "success") {
    return null;
  }

  return response.data;
}

export namespace SearchUsersQuery {
  export const keys = {
    all: ["user"],
    userSearch: (id: string | undefined, name: string) =>
      [...keys.all, id, "search", name] as const,
  } as const;

  export const minSearchKey = 3;

  export function useQuery(name: string) {
    const { data: session } = useSession();

    return useQueryTanstack({
      queryKey: keys.userSearch(session?.user?.id, name),
      queryFn: getUsers,
      enabled:
        !!session?.user?.id && Boolean(name) && name.length > minSearchKey,
    });
  }
}
